import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/kevin-meehan.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of Kevin Meehan"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Kevin Meehan"),
  /*#__PURE__*/_createElementVNode("p", null, "Kevin is a Non-Executive Director, Senior Business Leader and Alternative Asset Specialist, guiding the delivery of global, commercial business strategies for the Financial Services sector. His executive career includes several years with Credit Suisse as Managing Director of Prime Brokerage in Hong Kong and then Managing Director / Global Head of Prime Fund Services (PFS) in London, turning around PFS and directing a large-scale change programme to return it to profitability. He has now built a NED/Advisory portfolio leveraging 25+ years’ experience across all verticals of the hedge fund sector including asset management, fund admin, legal and prime brokerage to drive decision making.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}